export const c_about_modal_box__close_c_button_BackgroundColor = {
  "name": "--pf-c-about-modal-box__close--c-button--BackgroundColor",
  "value": "rgba(3, 3, 3, 0.4)",
  "var": "var(--pf-c-about-modal-box__close--c-button--BackgroundColor)"
};
export default c_about_modal_box__close_c_button_BackgroundColor;